import React from 'react'

const SectionFetcher: React.FC<{ url: string }> = ({ url }) => {
  return <iframe width="100%" height="100%" title='term-frame' src={url}></iframe>
}

export default SectionFetcher
